import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import { FormControl as MuiFormControl, InputLabel, Select, withStyles } from '@material-ui/core';
var FormControl = withStyles(function (theme) {
  return {
    root: {
      backgroundColor: 'transparent !important'
    }
  };
})(MuiFormControl);

var KailonaSelect = /*#__PURE__*/function (_Component) {
  _inherits(KailonaSelect, _Component);

  var _super = _createSuper(KailonaSelect);

  function KailonaSelect() {
    _classCallCheck(this, KailonaSelect);

    return _super.apply(this, arguments);
  }

  _createClass(KailonaSelect, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(FormControl, null, /*#__PURE__*/React.createElement(InputLabel, {
        htmlFor: this.props.name
      }, this.props.name), /*#__PURE__*/React.createElement(Select, _extends({}, this.props, {
        inputProps: {
          name: this.props.name
        }
      }), this.props.options.map(function (option) {
        return /*#__PURE__*/React.createElement("option", {
          value: option.value
        }, option.text);
      })));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return KailonaSelect;
}(Component);

export { KailonaSelect as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(FormControl, "FormControl", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/Select/KailonaSelect.js");
  reactHotLoader.register(KailonaSelect, "KailonaSelect", "/home/runner/html/nextcloud/apps/ehr/js/platform/ui/src/elements/Select/KailonaSelect.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();